// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.navbar-nav[data-v-6f240f0f]{\r\n  width: 200px !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
